module.exports = __webpack_public_path__ + "img/BT.927ecffd.svg";